module.exports = __webpack_public_path__ + "assets/3-Denver-Sales-Jobs-Roles.a8327df1.png";